import { Code2 } from "lucide-react";
import { ApiAccessCard } from "@/components/ApiAccessCard";

export default function ApiAccess() {
  return (
    <div className="space-y-6 animate-fade-up max-w-5xl" data-testid="api-access-page">
      <div><h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><Code2 className="w-7 h-7 text-primary" /> API Access</h1><p className="text-sm text-muted-foreground mt-1">Connect your accounting, HRIS or scheduling tools. Keys and webhooks here are locked to your company.</p></div>
      <ApiAccessCard />
    </div>
  );
}
